module.exports = __webpack_public_path__ + "static/img/bg_question1@2x.1359862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_question1@2x.png
// module id = ilZn
// module chunks = 1